/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type AddressSelector_user$ref = any;
type RequestModalSelectProject_user$ref = any;
export type RequestShippingQuoteForm_user$ref = any;
export type RequestShippingQuoteForm_user = {
    readonly profile: {
        readonly firstName: string | null;
        readonly lastName: string | null;
    } | null;
    readonly isVerifiedTrade: boolean | null;
    readonly " $fragmentRefs": AddressSelector_user$ref & RequestModalSelectProject_user$ref;
    readonly " $refType": RequestShippingQuoteForm_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "RequestShippingQuoteForm_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "profile",
            "storageKey": null,
            "args": null,
            "concreteType": "Profile",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "firstName",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "lastName",
                    "args": null,
                    "storageKey": null
                }
            ]
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isVerifiedTrade",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "FragmentSpread",
            "name": "AddressSelector_user",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "RequestModalSelectProject_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'cd142fb5aee4cc449b98b75363e6b14c';
export default node;
